import Coin_Icon from '@assets/svg/coin.svg';
import { EditOverlay, ProgressBar, Reward, RewardIcon, RewardName, RewardProgress, RewardStats } from './RewardItem.styled';
import Badges from '@models/Badges';
import Edit_Icon from '@assets/svg/edit.svg';
import { useI18n } from '@i18n/useI18n';
import Rewards from '@models/Rewards';

interface IProps {
  rewardItem?: any;
  profileCoins?: number;
  previewState?: number;
  setEditItem?: (number) => void;
}

const RewardItem = (props: IProps) => {
  const i18n = useI18n();

  const EditReward = (Id) => {
    if (props.setEditItem) props.setEditItem(props.rewardItem.id);
  };

  let Icon = Rewards[props.rewardItem.icon].icon;

  return (
    <Reward hidePointer={!props.setEditItem} onClick={() => EditReward(props.rewardItem)} previewState={props.previewState === 3}>
      {props.previewState ? null : (
        <EditOverlay>
          <Edit_Icon />
          <span>Edit Reward</span>
        </EditOverlay>
      )}
      <RewardStats>
        <span>
          {props.rewardItem.cost !== null ? props.rewardItem.cost : 0} <Coin_Icon />
        </span>
        <span>
          {props.rewardItem.stock === -1 ? null : props.rewardItem.stock !== null ? props.rewardItem.stock : 0}{' '}
          {props.rewardItem.stock === -1 ? null : i18n.t('reward-left')}
        </span>
      </RewardStats>
      <RewardIcon progress={props.previewState != 2}>
        <Icon />
      </RewardIcon>
      <RewardProgress>
        <ProgressBar progress={100} />
      </RewardProgress>
      <RewardName>
        <p>{i18n.t(props.rewardItem.title)}</p>
      </RewardName>
    </Reward>
  );
};

export default RewardItem;
